angular.module('website').controller('website.termsCtrl', ["$scope", "DataService", function($scope, DataService) {
  $scope.gymName = DataService.gym_name;
  $scope.terms = DataService.terms;
  $scope.title = DataService.terms_title;
  return $scope.termsTitle = $scope.title ? $scope.title : `${$scope.gymName} Terms and Conditions`;
}]);
